Shopware.Component.override('sw-sales-channel-create', import('./extension/sw-sales-channel-create'));

Shopware.Component.override('sw-sales-channel-detail', import('./extension/sw-sales-channel-detail'));

Shopware.Component.override('sw-sales-channel-detail-base', import('./extension/sw-sales-channel-detail-base'));
